<template>
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1100;">
    <div
      v-for="toast in toasts"
      :key="toast.id"
      :class="[
        'toast',
        'show',
        `border-${toast.variant}`,
        toast.variant === 'success' ? 'bg-success-subtle' :
        toast.variant === 'danger' ? 'bg-danger-subtle' :
        toast.variant === 'warning' ? 'bg-warning-subtle' :
        'bg-info-subtle'
      ]"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="toast-header">
        <i
          :class="[
            'bi',
            'me-2',
            toast.variant === 'success' ? 'bi-check-circle-fill text-success' :
            toast.variant === 'danger' ? 'bi-exclamation-triangle-fill text-danger' :
            toast.variant === 'warning' ? 'bi-exclamation-triangle-fill text-warning' :
            'bi-info-circle-fill text-info'
          ]"
        ></i>
        <strong class="me-auto">
          {{
            toast.variant === 'success' ? '成功' :
            toast.variant === 'danger' ? 'エラー' :
            toast.variant === 'warning' ? '警告' :
            '情報'
          }}
        </strong>
        <button
          type="button"
          class="btn-close"
          @click="removeToast(toast.id)"
          aria-label="閉じる"
        ></button>
      </div>
      <div class="toast-body">
        {{ toast.message }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const toasts = ref([])

const showToast = (message, variant = 'info', duration = 3000) => {
  const id = Date.now() + Math.random()
  const toast = {
    id,
    message,
    variant
  }

  toasts.value.push(toast)

  // 自動削除
  setTimeout(() => {
    removeToast(id)
  }, duration)
}

const removeToast = (id) => {
  const index = toasts.value.findIndex(toast => toast.id === id)
  if (index > -1) {
    toasts.value.splice(index, 1)
  }
}

// 外部から呼び出すメソッド
const success = (message, duration = 3000) => {
  showToast(message, 'success', duration)
}

const error = (message, duration = 5000) => {
  showToast(message, 'danger', duration)
}

const warning = (message, duration = 4000) => {
  showToast(message, 'warning', duration)
}

const info = (message, duration = 3000) => {
  showToast(message, 'info', duration)
}

// expose public methods
defineExpose({
  showToast,
  success,
  error,
  warning,
  info
})
</script>

<style scoped>
.toast-container {
  z-index: 1100;
}

.toast {
  min-width: 300px;
  margin-bottom: 0.5rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.toast.show {
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
